module.exports = __webpack_public_path__ + "static/media/Logo-Spectral-Solutions-200-2-01-01.4d39169b.png";